module.exports = __webpack_public_path__ + "static/media/loader.c356a5c8.gif";